import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ListItem, ListItemIcon, ListItemSecondaryAction, ListItemText, IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

import Progress from './Progress';

import { removeCharacter } from '../../Slices/uniqueKillsDataSlice';

const CharacterItem = ({ characterId, characterName }) => {
    const dispatch = useDispatch();
    const [editMode, setEditMode] = useState(false);
    const { characterKills, charactersStatus, active: queueActive } = useSelector(state => state.uniqueKillsData);

    const kills = characterKills[characterId];
    const status = charactersStatus[characterId];

    const onDelete = () => {
        dispatch(removeCharacter(characterName));
    };

    return (
        <ListItem button onClick={() => setEditMode(!editMode)}>
            <ListItemIcon>
                <img
                    width="42"
                    src={`https://images.evetech.net/characters/${characterId}/portrait`}
                    alt="Character profile portrait"
                />
            </ListItemIcon>
            <ListItemText primary={characterName} secondary={`Kills: ${kills?.length || 0}`} />
            <ListItemSecondaryAction>
                {editMode ? (
                    <>
                        <IconButton
                            key="zkill"
                            href={`https://zkillboard.com/character/${characterId}/`}
                            target="_blank"
                            rel="noreferrer"
                            size="large"
                        >
                            <img src="/zkillboard-favicon.png" alt="zkillboard logo" />
                        </IconButton>
                        {!queueActive && (
                            <IconButton key="onDelete" onClick={onDelete} size="large">
                                <DeleteIcon />
                            </IconButton>
                        )}
                    </>
                ) : (
                    <Progress status={status} />
                )}
            </ListItemSecondaryAction>
        </ListItem>
    );
};

export default CharacterItem;
